import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import type { SegmentMix } from '../../lib/api.js';
import { PALETTE, TOOLTIP_STYLE } from './ChartCard.js';

/** Donut of channel/segment revenue mix (chart #9). */
export function ChannelDonut({ mix }: { mix: SegmentMix }) {
  const data = [
    { name: 'Individual', value: mix.individual ?? 0 },
    { name: 'Company', value: mix.company ?? 0 },
    { name: 'Travel Agent', value: mix.travelAgent ?? 0 },
    { name: 'Block', value: mix.block ?? 0 },
  ].filter((d) => d.value > 0);

  if (data.length === 0) return <p className="text-sm text-slate-500">Sin datos de segmento.</p>;

  return (
    <ResponsiveContainer width="100%" height={280}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          innerRadius={60}
          outerRadius={100}
          paddingAngle={2}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={TOOLTIP_STYLE}
          formatter={(v: number) => `${(v * 100).toFixed(1)}%`}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}
